function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { useUniquePrefix } from "../../../hooks/useUniquePrefix";
var SimpleError = function(_param) {
    var width = _param.width, height = _param.height, title = _param.title, rest = _objectWithoutProperties(_param, [
        "width",
        "height",
        "title"
    ]);
    var uniqueID = useUniquePrefix();
    return _jsxs("svg", _objectSpread({}, rest, {
        width: width,
        height: height,
        viewBox: "0 0 369 375",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            _jsx("title", {
                children: title
            }),
            _jsxs("defs", {
                children: [
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "SimpleError-linearGradient-1"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#00A7FA"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#0076F3"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "-2.48949813e-15%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "SimpleError-linearGradient-4"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#0096F7"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#00FFD6"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "41.9900334%",
                        y1: "28.0875%",
                        x2: "55.2564598%",
                        y2: "72.515024%",
                        id: "".concat(uniqueID, "SimpleError-linearGradient-5"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#E4E6E7"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "SimpleError-linearGradient-8"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#DA66FF"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#9B66FF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "-2.48949813e-15%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "SimpleError-linearGradient-11"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#D266FF"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFA6FA"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "0%",
                        y1: "0%",
                        x2: "50%",
                        y2: "74.4382679%",
                        id: "".concat(uniqueID, "SimpleError-linearGradient-16"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "SimpleError-linearGradient-20"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#DA66FF"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#9B66FF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "62.112453%",
                        y1: "100%",
                        x2: "103.108255%",
                        y2: "70.8298152%",
                        id: "".concat(uniqueID, "SimpleError-linearGradient-29"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#00FFD6"
                            })
                        ]
                    }),
                    _jsx("circle", {
                        id: "".concat(uniqueID, "SimpleError-path-2"),
                        cx: "188.920002",
                        cy: "185.032002",
                        r: "81.7920008"
                    }),
                    _jsx("circle", {
                        id: "".concat(uniqueID, "SimpleError-path-12"),
                        cx: "46.6470004",
                        cy: "46.6470004",
                        r: "46.6470004"
                    }),
                    _jsx("circle", {
                        id: "".concat(uniqueID, "SimpleError-path-17"),
                        cx: "65.8170006",
                        cy: "65.8170006",
                        r: "65.8170006"
                    }),
                    _jsx("circle", {
                        id: "".concat(uniqueID, "SimpleError-path-22"),
                        cx: "65.8170006",
                        cy: "65.8170006",
                        r: "65.8170006"
                    }),
                    _jsx("circle", {
                        id: "".concat(uniqueID, "SimpleError-path-26"),
                        cx: "46.6470004",
                        cy: "46.6470004",
                        r: "46.6470004"
                    }),
                    _jsxs("filter", {
                        x: "-47.7%",
                        y: "-33.0%",
                        width: "195.4%",
                        height: "199.0%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-3"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "30",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "5",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "21",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "11.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.324501812 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-165.7%",
                        y: "-85.8%",
                        width: "431.4%",
                        height: "316.7%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-7"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "15",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "5",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "21.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "7.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-34.4%",
                        y: "-23.7%",
                        width: "168.7%",
                        height: "170.7%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-10"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "25",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "5",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "18.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "10.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.607843137 0 0 0 0 0.4 0 0 0 0 1 0 0 0 0.324501812 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.607843137 0 0 0 0 0.4 0 0 0 0 1 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsx("filter", {
                        x: "-16.4%",
                        y: "-16.4%",
                        width: "132.8%",
                        height: "132.8%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-14"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "8.94600009",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsx("filter", {
                        x: "-12.1%",
                        y: "-12.1%",
                        width: "124.1%",
                        height: "124.1%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-15"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "8.94600009",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsx("filter", {
                        x: "-15.9%",
                        y: "-15.9%",
                        width: "131.8%",
                        height: "131.8%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-19"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "8.94600009",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsx("filter", {
                        x: "-18.2%",
                        y: "-17.8%",
                        width: "136.4%",
                        height: "135.7%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-21"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "12.7800001",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsx("filter", {
                        x: "-15.9%",
                        y: "-15.9%",
                        width: "131.8%",
                        height: "131.8%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-24"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "8.94600009",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsx("filter", {
                        x: "-18.2%",
                        y: "-17.8%",
                        width: "136.4%",
                        height: "135.7%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-25"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "12.7800001",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsx("filter", {
                        x: "-16.4%",
                        y: "-16.4%",
                        width: "132.8%",
                        height: "132.8%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-28"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "8.94600009",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsx("filter", {
                        x: "-5.5%",
                        y: "-5.5%",
                        width: "110.9%",
                        height: "110.9%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-30"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "2.55600002",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsx("filter", {
                        x: "-12.1%",
                        y: "-12.1%",
                        width: "124.1%",
                        height: "124.1%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-31"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "8.94600009",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsx("filter", {
                        x: "-6.0%",
                        y: "-36.0%",
                        width: "112.0%",
                        height: "172.1%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "SimpleError-filter-33"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "3.44999993",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsx("path", {
                        d: "M185.934281,201.646002 C185.301789,201.646002 184.795803,201.459774 184.416307,201.087313 C184.036812,200.714853 183.847067,200.218246 183.847067,199.597477 L183.847067,195.779772 C183.973566,192.489701 184.843229,189.634211 186.456085,187.213215 C188.06894,184.792219 190.36169,182.091918 193.334403,179.112231 C195.611376,176.815389 197.303267,174.922075 198.410128,173.432231 C199.516984,171.942388 200.165285,170.328415 200.355032,168.590264 C200.418282,168.341957 200.449906,167.938463 200.449906,167.379772 C200.449906,164.524239 199.216564,162.258469 196.749845,160.582395 C194.283125,158.906321 191.405328,158.068297 188.116369,158.068297 C184.574412,158.068297 181.617555,158.983916 179.245709,160.815182 C176.873863,162.646448 175.340092,165.517457 174.644351,169.428297 C174.391354,170.793987 173.569126,171.476821 172.177643,171.476821 L168.003215,171.476821 C167.433972,171.476821 166.943798,171.290594 166.532678,170.918133 C166.121558,170.545672 165.916001,170.049065 165.916001,169.428297 C166.0425,166.014072 167.03866,162.863721 168.904512,159.977149 C170.770365,157.090577 173.395168,154.79377 176.779002,153.086657 C180.162835,151.379545 184.036792,150.526001 188.400989,150.526001 C193.018182,150.526001 196.907951,151.30195 200.070412,152.85387 C203.232874,154.405783 205.57306,156.438776 207.091041,158.952887 C208.609023,161.466998 209.368002,164.120742 209.368002,166.914198 C209.368002,170.080116 208.640647,172.811455 207.185915,175.108297 C205.731182,177.405139 203.549117,180.074402 200.639652,183.116166 C198.236182,185.661315 196.433606,187.818452 195.231871,189.587641 C194.030135,191.35683 193.334404,193.32774 193.144657,195.500428 C193.018158,197.238579 192.95491,198.542173 192.95491,199.411248 C192.638664,200.901091 191.84806,201.646002 190.583076,201.646002 L185.934281,201.646002 Z M185.686757,216.982002 C185.053988,216.982002 184.531962,216.771033 184.120662,216.349088 C183.709363,215.927143 183.503716,215.391605 183.503716,214.742459 L183.503716,209.094916 C183.503716,208.44577 183.709363,207.894004 184.120662,207.439602 C184.531962,206.9852 185.053988,206.758002 185.686757,206.758002 L191.571475,206.758002 C192.204243,206.758002 192.742089,206.9852 193.185027,207.439602 C193.627965,207.894004 193.84943,208.44577 193.84943,209.094916 L193.84943,214.742459 C193.84943,215.391605 193.627965,215.927143 193.185027,216.349088 C192.742089,216.771033 192.204243,216.982002 191.571475,216.982002 L185.686757,216.982002 Z",
                        id: "".concat(uniqueID, "SimpleError-path-6")
                    }),
                    _jsx("path", {
                        d: "M98.9555394,197.911079 C153.607175,197.911079 197.911079,153.607175 197.911079,98.9555394 C197.911079,44.3039041 153.607175,0 98.9555394,0 C44.3039041,0 0,44.3039041 0,98.9555394 C0,153.607175 44.3039041,197.911079 98.9555394,197.911079 Z M98.9555394,188.811719 C49.3293418,188.811719 9.09935994,148.581737 9.09935994,98.9555394 C9.09935994,49.3293418 49.3293418,9.09935994 98.9555394,9.09935994 C148.581737,9.09935994 188.811719,49.3293418 188.811719,98.9555394 C188.811719,148.581737 148.581737,188.811719 98.9555394,188.811719 Z",
                        id: "".concat(uniqueID, "SimpleError-path-9")
                    }),
                    _jsxs("radialGradient", {
                        cx: "50.5075786%",
                        cy: "40.3983801%",
                        fx: "50.5075786%",
                        fy: "40.3983801%",
                        r: "37.37968%",
                        gradientTransform: "translate(0.505076,0.403984),scale(0.166050,1.000000),rotate(90.000000),scale(1.000000,7.290929),translate(-0.505076,-0.403984)",
                        id: "".concat(uniqueID, "SimpleError-radialGradient-32"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#747474",
                                stopOpacity: "0.2"
                            }),
                            _jsx("stop", {
                                offset: "79.8960093%",
                                stopColor: "#8F8F8F",
                                stopOpacity: "0.0345052083"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#979797",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "SimpleError-path-34"),
                        x: "0",
                        y: "0",
                        width: "22.3776003",
                        height: "21.6672003"
                    })
                ]
            }),
            _jsxs("g", {
                stroke: "none",
                fill: "none",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: [
                    _jsx("g", {
                        id: "".concat(uniqueID, "SimpleError-Hero/Error/No-Connection"),
                        transform: "translate(10.000000, -358.000000)"
                    }),
                    _jsxs("g", {
                        transform: "translate(10.000000, 0.000000)",
                        children: [
                            _jsx("circle", {
                                stroke: "#E1E1E1",
                                cx: "186.5",
                                cy: "181.5",
                                r: "117.5"
                            }),
                            _jsx("circle", {
                                stroke: "#E1E1E1",
                                cx: "207.5",
                                cy: "194.5",
                                r: "117.5"
                            }),
                            _jsx("circle", {
                                stroke: "url(#".concat(uniqueID, "SimpleError-linearGradient-4)"),
                                cx: "188.920002",
                                cy: "185.032002",
                                r: "81.7920008",
                                strokeWidth: "2.55600002"
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "SimpleError-filter-3)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "SimpleError-path-2")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "SimpleError-linearGradient-1)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "SimpleError-path-2")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                id: "SimpleError-?",
                                opacity: "0.2",
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "SimpleError-filter-7)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "SimpleError-path-6")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "SimpleError-linearGradient-5)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "SimpleError-path-6")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(89.236001, 87.904001)",
                                children: [
                                    _jsxs("g", {
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "SimpleError-filter-10)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "SimpleError-path-9")
                                            }),
                                            _jsx("use", {
                                                fill: "url(#".concat(uniqueID, "SimpleError-linearGradient-8)"),
                                                fillRule: "evenodd",
                                                xlinkHref: "#".concat(uniqueID, "SimpleError-path-9")
                                            })
                                        ]
                                    }),
                                    _jsx("path", {
                                        d: "M98.9555394,197.911079 C153.607175,197.911079 197.911079,153.607175 197.911079,98.9555394 C197.911079,44.3039041 153.607175,0 98.9555394,0 C44.3039041,0 0,44.3039041 0,98.9555394 C0,153.607175 44.3039041,197.911079 98.9555394,197.911079 Z M98.9555394,188.811719 C49.3293418,188.811719 9.09935994,148.581737 9.09935994,98.9555394 C9.09935994,49.3293418 49.3293418,9.09935994 98.9555394,9.09935994 C148.581737,9.09935994 188.811719,49.3293418 188.811719,98.9555394 C188.811719,148.581737 148.581737,188.811719 98.9555394,188.811719 Z",
                                        stroke: "url(#".concat(uniqueID, "SimpleError-linearGradient-11)"),
                                        strokeWidth: "2.27483999"
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(188.542002, 49.186000)",
                                children: [
                                    _jsxs("g", {
                                        transform: "translate(11.880000, 11.880000)",
                                        children: [
                                            _jsx("mask", {
                                                id: "".concat(uniqueID, "SimpleError-mask-13"),
                                                fill: "white",
                                                children: _jsx("use", {
                                                    xlinkHref: "#".concat(uniqueID, "SimpleError-path-12")
                                                })
                                            }),
                                            _jsx("use", {
                                                fill: "#ECECEC",
                                                fillOpacity: "0.9",
                                                xlinkHref: "#".concat(uniqueID, "SimpleError-path-12")
                                            }),
                                            _jsx("g", {
                                                mask: "url(#".concat(uniqueID, "SimpleError-mask-13)"),
                                                children: _jsxs("g", {
                                                    transform: "translate(-125.244001, 19.170000)",
                                                    children: [
                                                        _jsx("circle", {
                                                            fill: "url(#".concat(uniqueID, "SimpleError-linearGradient-1)"),
                                                            filter: "url(#".concat(uniqueID, "SimpleError-filter-14)"),
                                                            cx: "130.356001",
                                                            cy: "99.6840009",
                                                            r: "81.7920008"
                                                        }),
                                                        _jsx("path", {
                                                            d: "M111.186001,222.372002 C172.592334,222.372002 222.372002,172.592334 222.372002,111.186001 C222.372002,49.7796683 172.592334,0 111.186001,0 C49.7796683,0 0,49.7796683 0,111.186001 C0,172.592334 49.7796683,222.372002 111.186001,222.372002 Z M111.186001,212.148002 C55.4262276,212.148002 10.2240001,166.945774 10.2240001,111.186001 C10.2240001,55.4262276 55.4262276,10.2240001 111.186001,10.2240001 C166.945774,10.2240001 212.148002,55.4262276 212.148002,111.186001 C212.148002,166.945774 166.945774,212.148002 111.186001,212.148002 Z",
                                                            fill: "url(#".concat(uniqueID, "SimpleError-linearGradient-8)"),
                                                            filter: "url(#".concat(uniqueID, "SimpleError-filter-15)")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    _jsx("circle", {
                                        stroke: "url(#".concat(uniqueID, "SimpleError-linearGradient-16)"),
                                        transform: "translate(58.527001, 58.527001) rotate(163.000000) translate(-58.527001, -58.527001) ",
                                        cx: "58.5270005",
                                        cy: "58.5270005",
                                        r: "46.6470004",
                                        strokeWidth: "1.41704641"
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(118.390667, 108.711152) rotate(-80.000000) translate(-118.390667, -108.711152) translate(25.390667, 15.711152)",
                                children: [
                                    _jsxs("g", {
                                        transform: "translate(26.838000, 26.838000)",
                                        children: [
                                            _jsx("mask", {
                                                id: "".concat(uniqueID, "SimpleError-mask-18"),
                                                fill: "white",
                                                children: _jsx("use", {
                                                    xlinkHref: "#".concat(uniqueID, "SimpleError-path-17")
                                                })
                                            }),
                                            _jsx("use", {
                                                fill: "#ECECEC",
                                                fillOpacity: "0.9",
                                                xlinkHref: "#".concat(uniqueID, "SimpleError-path-17")
                                            }),
                                            _jsx("g", {
                                                mask: "url(#".concat(uniqueID, "SimpleError-mask-18)"),
                                                children: _jsxs("g", {
                                                    transform: "translate(-100.034138, 33.438083)",
                                                    children: [
                                                        _jsx("circle", {
                                                            fill: "url(#".concat(uniqueID, "SimpleError-linearGradient-1)"),
                                                            filter: "url(#".concat(uniqueID, "SimpleError-filter-19)"),
                                                            cx: "96.0023908",
                                                            cy: "114.962083",
                                                            r: "84.3480008"
                                                        }),
                                                        _jsx("path", {
                                                            d: "M105.717405,211.351857 C163.947548,211.351857 211.152406,164.147 211.152406,105.916856 C211.152406,47.6867133 163.947548,0.481855415 105.717405,0.481855415 C47.4872619,0.481855415 0.282404082,47.6867133 0.282404082,105.916856 C0.282404082,164.147 47.4872619,211.351857 105.717405,211.351857 Z M101.952831,215.401566 C49.0163376,215.401566 6.10283043,172.488059 6.10283043,119.551565 C6.10283043,66.6150712 49.0163376,23.7015641 101.952831,23.7015641 C154.889325,23.7015641 197.802832,66.6150712 197.802832,119.551565 C197.802832,172.488059 154.889325,215.401566 101.952831,215.401566 Z",
                                                            fill: "url(#".concat(uniqueID, "SimpleError-linearGradient-20)"),
                                                            filter: "url(#".concat(uniqueID, "SimpleError-filter-21)")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    _jsx("circle", {
                                        stroke: "url(#".concat(uniqueID, "SimpleError-linearGradient-16)"),
                                        transform: "translate(92.655001, 92.655001) rotate(-51.000000) translate(-92.655001, -92.655001) ",
                                        cx: "92.6550009",
                                        cy: "92.6550009",
                                        r: "65.8170006",
                                        strokeWidth: "1.41704641"
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(273.834914, 239.436025) rotate(84.000000) translate(-273.834914, -239.436025) translate(197.334914, 162.936025)",
                                children: [
                                    _jsxs("g", {
                                        transform: "translate(10.602000, 10.602000)",
                                        children: [
                                            _jsx("mask", {
                                                id: "".concat(uniqueID, "SimpleError-mask-23"),
                                                fill: "white",
                                                children: _jsx("use", {
                                                    xlinkHref: "#".concat(uniqueID, "SimpleError-path-22")
                                                })
                                            }),
                                            _jsx("use", {
                                                fill: "#ECECEC",
                                                fillOpacity: "0.9",
                                                xlinkHref: "#".concat(uniqueID, "SimpleError-path-22")
                                            }),
                                            _jsx("g", {
                                                mask: "url(#".concat(uniqueID, "SimpleError-mask-23)"),
                                                children: _jsxs("g", {
                                                    transform: "translate(-100.034138, 33.438083)",
                                                    children: [
                                                        _jsx("circle", {
                                                            fill: "url(#".concat(uniqueID, "SimpleError-linearGradient-1)"),
                                                            filter: "url(#".concat(uniqueID, "SimpleError-filter-24)"),
                                                            cx: "96.0023908",
                                                            cy: "114.962083",
                                                            r: "84.3480008"
                                                        }),
                                                        _jsx("path", {
                                                            d: "M105.717405,211.351857 C163.947548,211.351857 211.152406,164.147 211.152406,105.916856 C211.152406,47.6867133 163.947548,0.481855415 105.717405,0.481855415 C47.4872619,0.481855415 0.282404082,47.6867133 0.282404082,105.916856 C0.282404082,164.147 47.4872619,211.351857 105.717405,211.351857 Z M101.952831,215.401566 C49.0163376,215.401566 6.10283043,172.488059 6.10283043,119.551565 C6.10283043,66.6150712 49.0163376,23.7015641 101.952831,23.7015641 C154.889325,23.7015641 197.802832,66.6150712 197.802832,119.551565 C197.802832,172.488059 154.889325,215.401566 101.952831,215.401566 Z",
                                                            fill: "url(#".concat(uniqueID, "SimpleError-linearGradient-20)"),
                                                            filter: "url(#".concat(uniqueID, "SimpleError-filter-25)")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    _jsx("circle", {
                                        stroke: "url(#".concat(uniqueID, "SimpleError-linearGradient-16)"),
                                        transform: "translate(76.419001, 76.419001) rotate(-80.000000) translate(-76.419001, -76.419001) ",
                                        cx: "76.4190007",
                                        cy: "76.4190007",
                                        r: "65.8170006",
                                        strokeWidth: "1.41704641"
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(133.040662, 247.884068) rotate(-170.000000) translate(-133.040662, -247.884068) translate(86.040662, 200.884068)",
                                children: [
                                    _jsxs("g", {
                                        children: [
                                            _jsx("mask", {
                                                id: "".concat(uniqueID, "SimpleError-mask-27"),
                                                fill: "white",
                                                children: _jsx("use", {
                                                    xlinkHref: "#".concat(uniqueID, "SimpleError-path-26")
                                                })
                                            }),
                                            _jsx("use", {
                                                fill: "#ECECEC",
                                                fillOpacity: "0.9",
                                                xlinkHref: "#".concat(uniqueID, "SimpleError-path-26")
                                            }),
                                            _jsx("g", {
                                                mask: "url(#".concat(uniqueID, "SimpleError-mask-27)"),
                                                children: _jsxs("g", {
                                                    transform: "translate(-116.298001, 12.780000)",
                                                    children: [
                                                        _jsx("circle", {
                                                            stroke: "none",
                                                            fill: "url(#".concat(uniqueID, "SimpleError-linearGradient-1)"),
                                                            filter: "url(#".concat(uniqueID, "SimpleError-filter-28)"),
                                                            cx: "121.410001",
                                                            cy: "106.074001",
                                                            r: "81.7920008",
                                                            fillRule: "evenodd"
                                                        }),
                                                        _jsx("circle", {
                                                            stroke: "url(#".concat(uniqueID, "SimpleError-linearGradient-29)"),
                                                            fill: "none",
                                                            filter: "url(#".concat(uniqueID, "SimpleError-filter-30)"),
                                                            transform: "translate(121.410001, 106.074001) rotate(-106.000000) translate(-121.410001, -106.074001) ",
                                                            cx: "121.410001",
                                                            cy: "106.074001",
                                                            r: "81.7920008",
                                                            strokeWidth: "2.55600002"
                                                        }),
                                                        _jsx("path", {
                                                            d: "M111.642908,223.21087 C173.049241,223.21087 222.828909,173.431202 222.828909,112.024869 C222.828909,50.6185364 173.049241,0.838868114 111.642908,0.838868114 C50.2365756,0.838868114 0.456907358,50.6185364 0.456907358,112.024869 C0.456907358,173.431202 50.2365756,223.21087 111.642908,223.21087 Z M111.642908,212.98687 C55.883135,212.98687 10.6809075,167.784643 10.6809075,112.024869 C10.6809075,56.2650957 55.883135,11.0628682 111.642908,11.0628682 C167.402682,11.0628682 212.604909,56.2650957 212.604909,112.024869 C212.604909,167.784643 167.402682,212.98687 111.642908,212.98687 Z",
                                                            stroke: "none",
                                                            fill: "url(#".concat(uniqueID, "SimpleError-linearGradient-8)"),
                                                            filter: "url(#".concat(uniqueID, "SimpleError-filter-31)"),
                                                            fillRule: "evenodd"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    _jsx("circle", {
                                        stroke: "url(#".concat(uniqueID, "SimpleError-linearGradient-16)"),
                                        cx: "46.6470004",
                                        cy: "46.6470004",
                                        r: "46.6470004",
                                        strokeWidth: "1.41704641"
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                id: "".concat(uniqueID, "SimpleError-People/Person"),
                                transform: "translate(33.000000, 204.000000)",
                                children: [
                                    _jsxs("g", {
                                        id: "".concat(uniqueID, "SimpleError-Bottom/Standing/2"),
                                        transform: "translate(22.000000, 63.000000)",
                                        children: [
                                            _jsx("path", {
                                                d: "M36.6370122,76.013879 C41.9417921,75.0881468 46.8060912,74.1081394 47.3297337,76.2291744 C47.8944462,78.5165649 45.7755602,79.1487245 43.9227274,80.1276057 C42.6875055,80.7801932 40.1318103,81.7124516 36.2556418,82.9243809 C33.1194252,83.6080717 31.0637388,83.6080717 30.0885828,82.9243809 C29.4450978,81.8639438 29.4450978,80.3787662 30.0885828,78.4688481 C32.2090371,77.2121679 33.9737033,76.46561 35.3825816,76.2291744 C35.5923809,76.1939662 35.8019733,76.1582939 36.0111234,76.1223479 Z M1.48774545,75.7601409 C3.64001247,74.4684984 5.43986413,73.9131246 6.88730041,74.0940194 C12.8077552,74.8339346 16.093299,73.330896 17.3254956,76.2823706 C17.8856469,77.6240983 16.9396858,78.0734799 15.4297975,78.6487135 C13.9447475,79.2144843 11.1017271,80.0294521 6.9007364,81.0936169 C3.78182684,81.4184305 1.79311875,81.1698896 0.934612132,80.3479941 C0.443741374,79.1782642 0.628119148,77.6489798 1.48774545,75.7601409 Z",
                                                fill: "#1F2023"
                                            }),
                                            _jsx("path", {
                                                d: "M30.9524045,-4.26325641e-14 C35.6224952,14.6658752 39.6722945,31.722006 39.6722945,39.5342422 L39.6722945,39.5342422 L39.6720003,41.3214856 C39.6705291,44.2599436 39.661702,47.0097791 39.6087394,49.7627481 L39.5851133,50.8645573 C39.4107508,58.2171268 38.8876633,65.7737916 37.3184008,77.1708107 C37.3184008,78.0998182 36.7530989,78.661354 35.6224952,78.855418 C33.5219894,79.2159621 31.8162725,79.1189301 30.5053447,78.564322 C27.7747057,59.414824 28.9691608,52.4742135 25.0360979,40.8041226 C24.7435619,39.9361169 24.4393044,39.0986084 24.1242377,38.282408 C23.9183543,39.6521273 23.7000934,41.0327932 23.4656006,42.4464005 C21.4753505,54.4443457 16.5401994,63.9658321 8.54720039,74.9617071 C8.10575375,75.7144241 7.11492301,76.1810688 5.5747082,76.361641 C3.70423519,76.5809321 2.28757399,76.3955472 1.32472461,75.8054862 C7.75741807,57.7075132 9.13542402,53.7901339 9.13542402,39.5342422 L9.13501168,39.1102673 C9.12512818,34.0665818 8.93802808,30.5926221 8.62313847,27.0961771 L8.5417824,26.220676 C7.98204138,20.3685933 7.07877099,14.0854839 6.06080036,-4.26325641e-14 L6.06080036,-4.26325641e-14 Z",
                                                fill: "#EEC200"
                                            }),
                                            _jsx("path", {
                                                d: "M9.09783073,-4.26325641e-14 C13.5008225,16.9931255 17.9577043,24.786421 21.5714807,32.4140262 L21.8748433,33.0584201 C22.6713027,34.7617551 23.4244334,36.4695206 24.1242377,38.282408 C23.9183543,39.6521273 23.7000934,41.0327932 23.4656006,42.4464005 C21.4753505,54.4443457 16.5401994,63.9658321 8.54720039,74.9617071 C8.10575375,75.7144241 7.11492301,76.1810688 5.5747082,76.361641 C3.70423519,76.5809321 2.28757399,76.3955472 1.32472461,75.8054862 C7.75741807,57.7075132 9.13542402,53.7901339 9.13542402,39.5342422 L9.13501168,39.1102673 C9.12512818,34.0665818 8.93802808,30.5926221 8.62313847,27.0961771 L8.5417824,26.220676 C7.98204138,20.3685933 7.07877099,14.0854839 6.06080036,-4.26325641e-14 L6.06080036,-4.26325641e-14 L9.09783073,-4.26325641e-14 Z",
                                                fill: "#000000",
                                                fillOpacity: "0.15"
                                            })
                                        ]
                                    }),
                                    _jsxs("g", {
                                        id: "".concat(uniqueID, "SimpleError-Body/4"),
                                        transform: "translate(0.000000, 5.000000)",
                                        children: [
                                            _jsx("path", {
                                                d: "M42.125888,16.6891585 C46.5238155,16.6891585 47.3670993,16.7975536 48.0170535,16.9338148 L48.1304286,16.9581338 C48.6189535,17.0646275 49.1100484,17.1846465 51.1068288,17.2821799 C51.4657823,17.2997131 51.8074377,17.3411226 52.132363,17.4074756 L52.183618,17.3995586 L52.183618,17.3995586 C62.9575556,19.8507769 71.542712,34.77869 71.542712,41.044987 C71.542712,47.3112839 64.9122805,56.7520287 60.9818398,57.9532742 C59.9210961,57.2202117 59.100332,55.9658538 58.5195476,54.1902007 C61.7393009,48.5749624 63.15724,44.1932245 62.773365,41.044987 C62.496174,38.7716867 60.7673702,36.1472696 57.5869536,33.1717355 L57.586107,49.7780362 C57.586107,61.7821407 61.2567048,62.9129092 52.6410569,65.6795182 C44.025409,68.4461272 24.9313879,71.7039662 26.6011503,62.1098497 C27.5225557,60.365607 28.0231236,58.1635105 28.2700247,55.7053957 C23.3482483,51.6001223 18.0763502,45.3406253 18.0763502,41.400187 C18.0763502,35.2246379 26.4146484,20.6365294 36.9687596,17.8690393 C38.5298008,17.1112098 40.2586656,16.6891585 42.125888,16.6891585 Z M28.0054936,38.2791812 L27.9150294,38.4333536 C27.3155589,39.4810814 26.9591148,40.4700259 26.8456972,41.400187 C26.6810633,42.7503835 27.185007,44.3678509 28.3575283,46.2525892 C28.2427287,43.5495514 28.0739032,40.8300183 28.0054936,38.2791812 Z",
                                                fill: "#472F74"
                                            }),
                                            _jsx("path", {
                                                d: "M28.0611472,33.2479692 C27.9589182,34.8008681 27.9577506,36.4988987 28.0054912,38.2790932 C27.3510378,39.3841208 26.9646667,40.4244935 26.8456972,41.400187 C26.6810343,42.7506215 27.1851846,44.368421 28.3581483,46.2535857 C28.4993517,49.5399631 28.5616978,52.8009882 28.2700867,55.7047787 C23.3482483,51.6001223 18.0763502,45.3406253 18.0763502,41.400187 C18.0763502,35.2252246 26.4130641,20.6393013 36.9657515,17.8698284 C31.8239832,20.3704993 28.5041395,26.5187442 28.0611472,33.2479692 Z",
                                                fill: "#000000",
                                                fillOpacity: "0.15"
                                            }),
                                            _jsx("path", {
                                                d: "M58.7245173,53.9904007 C55.9190257,55.4112007 54.4694351,56.2834579 54.4694351,57.812136 C54.4694351,59.0103267 55.7665574,61.4178617 57.86307,61.0094164 C59.9595825,60.6009711 60.4318084,59.2873759 61.2567048,57.812136 C60.3943736,55.4840445 59.8754486,54.7101663 58.7245173,53.9904007 Z",
                                                fill: "#DBB59D"
                                            })
                                        ]
                                    }),
                                    _jsxs("g", {
                                        id: "".concat(uniqueID, "SimpleError-Head/Back/1"),
                                        transform: "translate(33.000000, 0.000000)",
                                        children: [
                                            _jsxs("g", {
                                                transform: "translate(1.000000, 0.000000)",
                                                children: [
                                                    _jsx("mask", {
                                                        id: "".concat(uniqueID, "SimpleError-mask-35"),
                                                        fill: "white",
                                                        children: _jsx("use", {
                                                            xlinkHref: "#".concat(uniqueID, "SimpleError-path-34")
                                                        })
                                                    }),
                                                    _jsx("g", {}),
                                                    _jsx("path", {
                                                        d: "M13.3189595,2.37522659 C19.4777253,2.37522659 19.5070374,7.18669435 19.9331721,9.60178198 C20.4742971,12.6685689 19.5070374,17.4356721 17.8720409,18.3999846 C17.0087437,18.9091528 16.5337104,19.1396956 15.4409674,19.6298299 C13.9897545,20.2807509 14.2268137,23.4898468 14.2514049,25.1444035 L14.5632002,27.3504004 L6.03840008,27.3504004 L7.26590775,21.6297489 C7.55381321,20.1132128 8.5191197,16.4904955 7.92522666,15.854269 C6.18391778,13.9888371 5.36008601,12.782216 5.36008601,10.6560001 C5.36008601,7.62413916 6.64890009,2.37522659 13.3189595,2.37522659 Z",
                                                        fill: "#DBB59D",
                                                        mask: "url(#".concat(uniqueID, "SimpleError-mask-35)")
                                                    })
                                                ]
                                            }),
                                            _jsx("path", {
                                                d: "M5.50668583,16.0720734 C6.07070459,17.4512121 7.20761267,19.2049602 9.21497832,19.2049602 C11.222344,19.2049602 14.3870328,17.7449072 14.3870328,15.0238689 C14.3870328,13.5102391 14.4692422,13.4290578 13.397337,12.0544789 C12.9508632,11.4819344 12.9359427,10.5795693 13.8826766,9.76553893 C14.8294104,8.95150853 16.1349612,10.3165499 16.1349612,11.8815632 C16.1349612,12.9249054 16.6587341,12.9249054 17.7062797,11.8815632 C16.5722297,7.96456847 17.1846954,6.18055533 19.5436766,6.52952376 C22.697923,6.64669756 19.3227173,0.288913808 12.8854109,0.491123679 C1.76078266,1.01457632 4.94266708,14.6929346 5.50668583,16.0720734 Z",
                                                fill: "#3C3226"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            _jsx("ellipse", {
                                id: "".concat(uniqueID, "SimpleError-Oval"),
                                fill: "url(#".concat(uniqueID, "SimpleError-radialGradient-32)"),
                                filter: "url(#".concat(uniqueID, "SimpleError-filter-33)"),
                                cx: "87.443128",
                                cy: "349.636646",
                                rx: "86.5",
                                ry: "14.363354"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
SimpleError.defaultProps = {
    height: 400,
    width: 400
};
SimpleError.isCarinaIllustration = true;
export default SimpleError;
